export default function Contact() {
  return (
    <section id="contact" className="bg-cream py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-tankan/10 text-tankan text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / CONTACT
          </span>
          <h2 className="text-3xl md:text-4xl font-rounded font-black text-kiln mb-4">
            食べたくなったら、電話一本。
          </h2>
          <p className="text-kiln/80 font-rounded text-base">
            ご予約・ご質問、お気軽にどうぞ。
          </p>
        </div>

        {/* Phone big */}
        <div className="bg-kiln rounded-2xl p-8 text-center">
          {/* Warm message before phone */}
          <div className="mb-6">
            <p
              className="text-white/90 font-rounded text-base md:text-lg"
              style={{ lineHeight: '2.0' }}
            >
              予約なしでもふらっとどうぞ。<br />
              窯が温まっていれば、いつでも焼きます。
            </p>
          </div>

          <p className="text-white/60 font-rounded text-xs mb-2 tracking-widest">TEL</p>
          <a
            href="tel:0997-69-4091"
            className="flex items-center justify-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
          >
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-phone-fill text-tankan-light text-3xl" />
            </div>
            <span className="text-white font-rounded font-black text-4xl md:text-5xl tracking-wide">
              0997-69-4091
            </span>
          </a>
          <p className="text-white/60 font-rounded text-xs mt-3">
            営業時間：10:00〜18:00（火・水・金・土・日）
          </p>
          <div className="mt-5 border-t border-white/10 pt-5 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://www.instagram.com/nakamura0v0kensetsu.ukenson/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-rounded font-bold text-sm px-6 py-3 rounded-full cursor-pointer transition-colors whitespace-nowrap"
            >
              <i className="ri-instagram-line text-lg" />
              Instagram DM でも受付中
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
